import { getMicroappKey } from '../routing/getMicroappKey';
export const isMicroapp = microapp => {
  const microappKey = getMicroappKey();
  return microappKey === microapp;
};